export default "__VITE_ASSET__SyTvK5yx__"